import React, { useState } from 'react';
import { Button, Paper, Typography, Box, Alert } from '@mui/material';
import { s3Service } from '../services/s3Service';

interface CorsTestProps {
  fontFamily?: string;
}

export const CorsTest: React.FC<CorsTestProps> = ({ fontFamily = 'JetBrains Mono' }) => {
  const [testResult, setTestResult] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const testS3Connection = async () => {
    setLoading(true);
    setTestResult('Testing S3 connection...');

    try {
      const folders = await s3Service.listFolders();
      
      setTestResult(`✅ Success! Found ${folders.length} folders: ${folders.join(', ')}`);
    } catch (error: any) {
      console.error('S3 Test Error:', error);
      setTestResult(`❌ Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 3, mb: 3, fontFamily }}>
      <Typography variant="h6" gutterBottom sx={{ fontFamily }}>
        🔍 CORS Test Panel
      </Typography>
      
      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <Button 
          variant="contained" 
          onClick={testS3Connection}
          disabled={loading}
          sx={{ fontFamily }}
        >
          Test S3 Connection
        </Button>
      </Box>

      {testResult && (
        <Alert 
          severity={testResult.includes('✅') ? 'success' : 'error'}
          sx={{ mt: 2, fontFamily }}
        >
          <pre style={{ margin: 0, whiteSpace: 'pre-wrap', fontFamily }}>{testResult}</pre>
        </Alert>
      )}

      <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary', fontFamily }}>
        <strong>Debugging Tips:</strong>
        <br />• Open browser DevTools → Network tab before testing
        <br />• Check Console for detailed error messages
        <br />• If you see CORS errors, apply the CORS config to S3 bucket
      </Typography>
    </Paper>
  );
}; 